import React, { useState } from 'react';
import classNameBind from 'classnames/bind';

import { TextField } from '../../../TextField';
import Button from '../../../Button';
import styles from './PageForm.module.css';

const bindClasses = classNameBind.bind(styles);

const PageForm = ({
  label,
  placeholder,
  onChange,
  lastPage,
}) => {
  const [page, setPage] = useState('');
  const changePage = (event) => {
    const newPage = Math.min(Math.max(event.target.value, 1), lastPage);
    setPage(newPage);
  };

  return (
    <div
      className={bindClasses('wrapper')}
      data-ppuc-id="Pagination.PageForm"
    >
      <TextField
        label={label}
        placeholder={placeholder}
        name="page"
        type="number"
        autoFocus
        extraMinWidth
        value={page}
        onChange={changePage}
      />
      <Button
        appearance="primary"
        icon="checkmark"
        onClick={() => { onChange(page || placeholder); }}
        minimalWidth
      />
    </div>
  );
};

export { PageForm };
